import Flickity from 'flickity';

const moduleName = 'carousel';

export function carousel () {
    const max1000 = window.matchMedia('(max-width: 1000px)');
    const reviewsCarousel = document.querySelector('.js-reviews-carousel');
    if (reviewsCarousel) {
        const screenWidth = window.screen.width;
        const wrapperWidth = reviewsCarousel.parentNode.clientWidth;
        const offset = (screenWidth - wrapperWidth) / 2;
        let freeScroll = true;
        let pageDots = false;
        let contain = true;
        //let cellAlign = 'left';
        if(max1000.matches)
        {
            freeScroll = false;
            pageDots = true;
            contain = false;
            //cellAlign = 'center';
        }
        const eqSetOffset = (flkty) => {
            if(max1000.matches)
            {
                flkty.x = flkty.x + 0;
                flkty.positionSlider();
            }
            else{
                flkty.x = flkty.x + offset;
                flkty.positionSlider();
            }
        }
        const flkty = new Flickity(reviewsCarousel, {
            // options
            cellAlign: 'left',
            contain: contain,
            freeScroll: freeScroll,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: pageDots,
            percentPosition: '30%',
            // selectedAttraction: 0.01,
            // friction: 0.15
            on: {
                ready: function() {
                    eqSetOffset(this);
                    this.element.classList.add('_init');
                },

            }
        });


    }

    const ratesCarousel = document.querySelector('.js-rates-carousel');
    if (ratesCarousel) {
        const eqSetOffset = (flkty) => {
            flkty.x = flkty.x + 20;
            flkty.positionSlider();
        }
        const flkty = new Flickity(ratesCarousel, {
            // options
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: true,
            watchCSS: true,
            //percentPosition: '30%',
            // selectedAttraction: 0.01,
            // friction: 0.15
            on: {
                ready: function() {
                    eqSetOffset(this);
                },

            }
        });
    }
}
